// src/App.js
import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { StyleProvider } from "./context/StyleContext";
import Background from "./components/Background";
import AnimatedRoutes from "./components/AnimatedRoutes";
import FloatingParticles from "./components/FloatingParticles";
import InfoPopup from "./components/InfoPopup";

function App() {
  return (
    <StyleProvider>
      <div className="relative w-full h-screen">
        <Background />
        <InfoPopup />
        <FloatingParticles count={6} />
        <div className="relative z-10 flex items-center justify-center w-full h-full">
          <Router>
            <AnimatedRoutes />
          </Router>
        </div>
      </div>
    </StyleProvider>
  );
}

export default App;
